import { defineComponent as _defineComponent } from 'vue';
import { computed, toRef } from "vue";
import {} from "@/api/fileSources";
import { useConfigurationTemplateUpgrade } from "@/components/ConfigTemplates/useConfigurationTesting";
import { useInstanceRouting } from "./routing";
export default /*#__PURE__*/ _defineComponent({
    __name: 'UpgradeForm',
    props: {
        instance: null,
        latestTemplate: null
    },
    setup(__props) {
        const props = __props;
        const editTestUrl = "/api/file_source_instances/{uuid}/test";
        const editUrl = "/api/file_source_instances/{uuid}";
        const title = computed(() => `Upgrade File Source ${props.instance.name}`);
        const { error, ActionSummary, inputs, InstanceForm, loadingMessage, onForceSubmit, onSubmit, testRunning, testResults, showForceActionButton, submitTitle, } = useConfigurationTemplateUpgrade("file source", toRef(props, "instance"), toRef(props, "latestTemplate"), editTestUrl, editUrl, useInstanceRouting);
        return { __sfc: true, editTestUrl, editUrl, props, title, error, ActionSummary, inputs, InstanceForm, loadingMessage, onForceSubmit, onSubmit, testRunning, testResults, showForceActionButton, submitTitle };
    }
});
